import React, { useState, useEffect } from 'react';
import './style.css';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import http from '../../services/http-service'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import GeneralConfiguration from './general-configuration';
import MutualInvite from './pre-boarded-employees'
import Notifications from './notifications'
import { Typography } from '@mui/material';
import SetPayAttributes from './set-pay-attributes';
import { useLocation } from 'react-router-dom';



function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

function Configuration(props) {

    let query = useQuery();
    console.log("hh", query);
    const userInfo = JSON.parse(localStorage.getItem('loginUser'))
    const [value, setValue] = React.useState('1');
    const [employerList, setEmployerList] = useState([]);
    const [employer, setEmployer] = useState({})
    const [open, setOpen] = useState(false);
    const [employerCode, setEmployerCode] = useState('');
    const [payAttributes, setPayAttributes] = useState({})
    const [viewPayAttributes, setViewPayAttributes] = useState(false)
    const [employeerName , setEmployeerName] = useState('')
    console.log('namebymukul', employeerName);
    useEffect(() => {
        if (query.get("id")) {
            setEmployerCode(query.get("id"))
        } else {
            setEmployerCode('')
        }
        if (userInfo.roles !== 3)
            getEmployerData()
        if (userInfo.roles === 3){
            setEmployerCode(userInfo.employer_code)
            getEmployerDataById(userInfo.id)
        }
        // eslint-disable-next-line    
    }, [props])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };

    const setEmployeerNameThroughParams = (data) => {
         data.forEach(ele => {
            if(ele.employer_id === query.get("id")){
                // setEmployeerName(ele.name)
                setEmployer(ele)
            }
        })
       
    }

    const getEmployerData = () => {
        handleToggle()
        http('admin/company_list/', 'GET')
            .then(res => {
                if (res.data.status) {
                    if (Array.isArray(res.data.data)){
                        setEmployerList(res.data.data)
                        if (query.get("id")){
                            setEmployeerNameThroughParams(res.data.data) 
                        }
                    }
                       
                    else {
                        let arr = []
                        arr.push(res.data.data)
                        setEmployerList(arr)
                        if (query.get("id")){
                            setEmployeerNameThroughParams(arr) 
                        }
                    }

                }
                else {
                    toast.error(res.data.message,{
                        toastId: "toastId1"
                      })
                }
                handleClose()
            },
                err => {
                    handleClose()
                })
    }

    const getEmployerDataById = (id) => {
        handleToggle()
        http('admin/company_list/', 'GET', '', {id: id})
            .then(res => {
                if (res.data.status) {
                    setEmployer(res.data.data)
                }
                else {
                    toast.error(res.data.message,{
                        toastId: "toastId2"
                      })
                }
                handleClose()
            },
                err => {
                    handleClose()
                    console.log('err....', err)
                })
    }

    const handleChildCallback = (childData) => {
        console.log('employerbymukul',employer);
        if (!employer.user_uploaded_or_not) {
            let newName = employeerName ? employeerName : employer.name
            toast.error(newName + " don't have any employee, please add employee first! ",{
                toastId: "toastId3"
              })
        }
        else if((!childData.fromSetAttributes && !childData.payDetermination) || (!childData.fromSetAttributes && !childData.payFrequency)){
            toast.error("Please select pay frequency and pay determination first!",{
                toastId: "toastId4"
              })
        }
        else {
            let data = {
                'employerCode': employerCode,
                'payDetermination': childData.payDetermination,
                'payFrequency': childData.payFrequency
            }
            setPayAttributes(data)
            setViewPayAttributes(childData.viewSetAttrComponents)
        }
    }

    return (
        <div className='commonPageDiv'>
            <ToastContainer />

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container spacing={2}>
                <Grid item xs={6} md={9}>
                    <Typography variant="h1" component="h1" className='settingHeading'>
                        Settings
                    </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                    {userInfo.roles !== 3 ? (
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Select Employer</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                name='employer' id="employer"
                                value={employerCode}
                                label="Please select employer"
                                onChange={(e) => {
                                    setEmployerCode(e.target.value)
                                    setValue('1');
                                    setViewPayAttributes(false)
                                    let employer = employerList.find(elem => { return elem.employer_id === e.target.value })
                                    setEmployer(employer)
                                }}
                            >
                                <MenuItem value="" disabled="true">Please select</MenuItem>
                                {
                                    employerList.map((data, index) => (
                                        <MenuItem key={'data.code' + index} value={data.employer_id}>{data.name + " (" + data.employer_id + ")"}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    ) : (
                        <div></div>
                    )}

                </Grid>
            </Grid>

            {employerCode ? (
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className='confogTabTopRow'>
                            <TabList onChange={handleChange} aria-label="lab API tabs example">
                                <Tab label="General" value="1" className='textTransformDefault' />
                                <Tab label="Notification" value="2" className='textTransformDefault' />
                                <Tab label="Pre-boarded Employees" value="3" className='textTransformDefault' />
                            </TabList>
                        </Box>
                        <TabPanel value="1" className='confogTabPanel'>
                            {
                                !viewPayAttributes ?
                                    (<GeneralConfiguration employerCode={employerCode} employer={employer} handleChildCallback={handleChildCallback} />) :
                                    (<SetPayAttributes payAttributes={payAttributes} handleChildPayAttriutesCallback={handleChildCallback} />)
                            }
                         
                        </TabPanel>
                        <TabPanel value="2" className='confogTabPanel'>
                            <Notifications employerCodeForNotification={employerCode} />
                        </TabPanel>
                        <TabPanel value="3" className='confogTabPanel'>
                            <MutualInvite employerCodeForMutualInvite={employerCode} />
                        </TabPanel>
                    </TabContext>


                </Box>
            ) : (
                <div className='recordNotFoundDiv'>
                    <h2>Please select employer first.</h2>
                </div >
            )}

        </div>
    );
}





export default Configuration;